import React, {Component} from 'react';
import config from './config';
import groupBy from 'lodash/groupBy'
import forEach from 'lodash/forEach'

const engToNepaliDigit = (ed) => {
  if (ed === null || ed === undefined) return null;
  return String(ed).split("").map(d => String.fromCharCode(d.charCodeAt(0) + 2358)).join("")
}

class WorldCupContainer extends Component {
  state = {
    data: [],
    loading: false
  }

  componentDidMount() {
    this.setState({loading: true})
    fetch(`${config.api_base_url}/pubworldcup`)
    .then(r => r.json())
    .then(res => {
      this.setState({
        data: res.data,
        loading: false
      })
    })
  }

  render() {
    const {height, width} = this.props;

    if(this.state.loading) {
      return (
        <div style={{width, height, textAlign: 'center', position: 'relative',fontFamily: 'Helvetica'}}>
          <p style={{fontSize: 12, position: 'absolute', width: 150, height: 10, left: width/2 - 75, top: height/2 - 5 }}>
          विश्वकप
          </p>
        </div>
      )
    }

    const data = groupBy(this.state.data, 'group');

    const tables = [];
    forEach(data, (_data, group) => {
      tables.push(this.renderTable(group, _data)) 
    })
    return (
      <div className="uk-grid">
        {tables}
      </div>
    )
  }


  renderTable(group, data) {
    return (
      <div className="uk-width-medium-1-4 uk-margin-bottom">
        <div style={{background: "#fff", fontSize: 12}}>
          <p className="uk-text-center" style={{margin: 0}}>{group}</p>
          <table className="__viz_wc" style={{width: '100%'}}>
            <thead>
              <tr>
                <th key="country_code"></th>
                <th key="mp">MP</th>
                <th key="w">W</th>
                <th key="l">L</th>
                <th key="t">T</th>
                <th key="gd">GD</th>
                <th key="gf">GF</th>
                <th key="ga">GA</th>
                <th key="pt">Pt</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((d) => {
                  return (
                    <tr key={d.country_code}>
                      <td key="country_code">{d.country}</td>
                      <td key="mp">{d.mp}</td>
                      <td key="w">{d.won}</td>
                      <td key="l">{d.lost}</td>
                      <td key="t">{d.tie}</td>
                      <td key="gd">{d.gd}</td>
                      <td key="gf">{d.gf}</td>
                      <td key="ga">{d.ga}</td>
                      <td key="pt">{d.points}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }

}

export default WorldCupContainer;


// WEBPACK FOOTER //
// ./src/WorldCupContainer.js